export default {
  canWrite(context) {
    const canWrite = context && context.accessRights && context.accessRights.write;
    return canWrite;
  },
  canRead(context) {
    const canRead = context && context.accessRights && context.accessRights.read;
    return canRead;
  },
  canDelete(context) {
    const canDelete = context && context.accessRights && context.accessRights.delete;
    return canDelete;
  }
};
